import { Directive, input } from '@angular/core';

import type { AssistantLinkTarget } from '@core/tellent-assistant-types';

import { injectTellentAssistantLinkOpener } from './link-opener.token';

/**
 * Renders an assistant link target as a plain anchor (href = web /switch URL)
 * while letting a host-provided opener take over activation — native hosts
 * navigate in-app instead of following the web link. Without an opener the
 * anchor behaves as a regular link.
 */
@Directive({
  selector: 'a[tellentAssistantLink]',
  host: {
    '[attr.href]': 'tellentAssistantLink()?.url ?? null',
    '(click)': 'onClick($event)',
  },
})
export class TellentAssistantLinkDirective {
  private readonly opener = injectTellentAssistantLinkOpener({ optional: true });

  public readonly tellentAssistantLink = input.required<AssistantLinkTarget | null>();

  protected onClick(event: MouseEvent): void {
    const target = this.tellentAssistantLink();
    if (target && this.opener?.(target)) {
      event.preventDefault();
    }
  }
}
